import { render, staticRenderFns } from "./cardManageDetail.vue?vue&type=template&id=c2c248bc&scoped=true&"
import script from "./cardManageDetail.vue?vue&type=script&lang=js&"
export * from "./cardManageDetail.vue?vue&type=script&lang=js&"
import style0 from "./cardManageDetail.vue?vue&type=style&index=0&id=c2c248bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c248bc",
  null
  
)

export default component.exports